import * as React from "react";
import {
    Admin,
    Create,
    Datagrid,
    defaultTheme,
    EditButton,
    List,
    Resource,
    ShowButton,
    SimpleForm,
    TextField,
    TextInput,
} from 'react-admin';
import authProvider from "./authProvider";
import myDataProvider from "./dataProvider";
import {ProductTypeCreate, ProductTypeEdit, ProductTypeList} from "./components/seller/ProductType";
import {ProductCreate, ProductEdit, ProductList, ShowProduct} from "./components/seller/Product";
import {ManufacturerCreate, ManufacturerEdit, ManufacturerList} from "./components/seller/Manufacturer";
import {MerchandiseCreate, MerchandiseEdit, MerchandiseList} from "./components/seller/Merchandise";
import {WarrantyCreate, WarrantyEdit, WarrantyList} from "./components/seller/Warranty";
import {MyProductList} from "./components/customer/MyProduct";
import CustomRoutes from "./customRoutes";
import {createTheme} from "@material-ui/core/styles";
import Login from "./components/auth/login";
import CustomLayout from './components/customLayout';
import {QueryClient, QueryClientProvider} from "react-query";
import HomePage from "./components/HomePage";
import polyglotI18nProvider from "ra-i18n-polyglot"; // Install this package
import engMessages from "ra-language-english";
import {LabelList, ShowLabel} from "./components/seller/Label"; // Install this package


const theme = createTheme({
    ...defaultTheme,
    sidebar: {
        width: 240,
        closeWidth: 55,
    },
})

const queryClient = new QueryClient();

const App = () => {
    const i18nProvider = polyglotI18nProvider((locale) => engMessages, "en", {
        allowMissing: true,
        onMissingKey: (key, _, __) => key,
    });
    return (
        <QueryClientProvider client={queryClient}>
            <Admin dashboard={HomePage} dataProvider={myDataProvider} authProvider={authProvider}
                   i18nProvider={i18nProvider}
                   customRoutes={CustomRoutes} theme={theme}
                   loginPage={Login} layout={CustomLayout} error>
                {permissions => [
                    permissions === 'SELLER' ? [
                        <Resource name="product"
                                  options={{label: 'Prodotti'}}
                                  list={ProductList}
                                  create={ProductCreate}
                                  edit={ProductEdit}
                                  show={ShowProduct}/>,
                        <Resource name="product_type"
                                  options={{label: 'Tipologia di prodotti'}}
                                  list={ProductTypeList}
                                  create={ProductTypeCreate}
                                  edit={ProductTypeEdit}/>,
                        <Resource name="manufacturer"
                                  options={{label: 'Produttori'}}
                                  list={ManufacturerList}
                                  create={ManufacturerCreate}
                                  edit={ManufacturerEdit}/>,
                        <Resource name="merchandise"
                                  options={{label: 'ColorCode'}}
                                  list={MerchandiseList}
                                  create={MerchandiseCreate}
                                  edit={MerchandiseEdit}/>,
                        <Resource name="warranty"
                                  options={{label: 'Garanzia'}}
                                  list={WarrantyList}
                                  create={WarrantyCreate}
                                  edit={WarrantyEdit}/>,
                        <Resource name="customers"
                                  options={{label: 'Clienti'}}
                                  list={CustomerList}
                                  create={CustomerCreate}/>,
                        <Resource name="label"
                                  options={{label: 'Etichette'}}
                                  list={LabelList}
                                  show={ShowLabel}
                                  />] : null,
                    permissions === 'CUSTOMER' ? [
                        <Resource name="my-products"
                                  options={{
                                      label: "I miei prodotti"
                                  }}
                                  list={MyProductList}
                        />
                    ] : null,
                ]}
            </Admin>
        </QueryClientProvider>
    );
}

export const CustomerCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name"/>
            <TextInput source="streetAddress"/>
            <TextInput source="email"/>
            <TextInput source="phoneNumber"/>
            <TextInput source="passwordHash"/>
        </SimpleForm>
    </Create>
);

export const CustomerList = (props) => (
    <List {...props} perPage={25}>
        <Datagrid rowClick="edit">
            <TextField source="name"/>
            <TextField source="email"/>
            <TextField source="phoneNumber"/>
            <ShowButton/>
            <EditButton/>
        </Datagrid>
    </List>
);

export default App;
